import {AddSchema, GetDoc, GetDocs, CreateAccessor, MGLClass} from "mobx-graphlink";
import {emptyArray} from "js-vextensions";

export const GetStory = CreateAccessor((id: string|n): Story|n=>{
	return GetDoc({}, a=>a.stories.get(id!));
});
export const GetStories = CreateAccessor((userID: string|n): Story[]=>{
	if (userID == null) return emptyArray; // if we aren't signed-in, don't even try to make request (the security-rules will make it fail)
	return GetDocs({
		params: {filter: {creator: userID != null && {equalTo: userID}}},
	}, a=>a.stories);
});

@MGLClass({table: "stories"})
export class Story {
	constructor(data?: Partial<Story>) { Object.assign(this, data); }
	id: string;
	creator: string;
	createdAt: number;

	title = "<unnamed>";
	promptVariables = [] as Array<{name: string, value: string}>;
	systemPrompt = "";
	standardAddendum = "";
	//startMessageIds: string[];
}
AddSchema("Story", {
	properties: {
		id: {type: "string"},
		creator: {type: "string"},
		createdAt: {type: "number"},

		title: {type: "string"},
		promptVariables: {
			items: {
				type: "object",
				properties: {
					name: {type: "string"},
					value: {type: "string"},
				},
			},
		},
		systemPrompt: {type: "string"},
		standardAddendum: {type: "string"},
		//startMessageIds: {items: {type: "string"}},
	},
	//required: [...],
});